import { createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/widgets/app-shell/app-shell.ui";

const HomePage = () => <AppShell />;

export const Route = createFileRoute("/")({
  component: HomePage,
});
